import React, { useContext } from "react";
import { ShakaPlayer, useAsyncError } from "sprint-common-web";

import { AuthConfigContext } from "../../../../../../../core/configuration/auth/AuthConfigurationContext";
import { AppConfigContext } from "../../../../../../../core/configuration/Configuration";
import { AuthContext } from "../../../../../../../core/security/AuthProvider";
import { PreviewLoadingError } from "../PreviewLoadingError";

export interface VideoPreviewProps {
    cloudFileId: string;
    manifestUrl: string;
    width?: string;
}

export const VideoPreview = ({ cloudFileId, manifestUrl, width }: VideoPreviewProps): JSX.Element => {
    const appConfigContext = useContext(AppConfigContext);
    const authConfigContext = useContext(AuthConfigContext);
    const authContext = useContext(AuthContext);
    const throwError = useAsyncError();

    const handleError = () => {
        throwError(new PreviewLoadingError());
    };

    const userTokens = {
        accessToken: authContext.sprintUser.accessToken,
        appClientId: authConfigContext.clientId,
        cloudFileId,
        environment: appConfigContext.environment
    };

    const licenceCustomData = btoa(JSON.stringify(userTokens));
    const licenceServer = appConfigContext.masterConfig.drmLicenceServer;

    return (
        <ShakaPlayer
            manifestUrl={manifestUrl}
            onError={handleError}
            width={width}
            licenceCustomData={licenceCustomData}
            licenceServer={licenceServer}
            accessToken={authContext.sprintUser.accessToken}
        />
    );
};
